<template>
  <div :class="wrapClass" class="small">
    <div class="stars">
      <div class="star" :class="{filled: stars >= 1}"></div>
      <div class="star" :class="{filled: stars >= 2}"></div>
      <div class="star" :class="{filled: stars >= 3}"></div>
      <div class="star" :class="{filled: stars >= 4}"></div>
      <div class="star" :class="{filled: stars >= 5}"></div>
    </div>
    <div class="num">{{ stars }}</div>
  </div>
</template>

<script>
export default {
  props: {
    wrapClass: String,
    stars: Number
  }
}
</script>
